/**
 * @file Album folder tags related mutations.
 */

import gql from 'graphql-tag';

import {
  AlbumAlbumFolderTagDetails,
  AlbumFolderTagDetails,
  AlbumPhotoAlbumFolderTagDetails,
  AlbumFolderPhotoSearchDetails,
  AlbumPhotoSearchDetails,
  AlbumFolderTagLevelDetails,
  UniformAlbumFolderTagLevelTeam,
} from '../fragments/album-folder-tags';
import {
  IdentityAlbumFolderTagBaseDetails,
  IdentityAlbumFolderUniformTagDetails,
} from '../fragments/identity';

export const albumFolderTagCreate = gql`
  mutation albumFolderTagCreate($input: AlbumFolderTagCreateInput!) {
    albumFolderTagCreate(input: $input) {
      album_folder_tag {
        ...AlbumFolderTagDetails
      }
    }
  }
  ${AlbumFolderTagDetails}
`;

export const albumFolderTagUpdate = gql`
  mutation albumFolderTagUpdate($input: AlbumFolderTagUpdateInput!) {
    albumFolderTagUpdate(input: $input) {
      album_folder_tag {
        ...AlbumFolderTagDetails
      }
    }
  }
  ${AlbumFolderTagDetails}
`;

export const albumFolderTagDelete = gql`
  mutation albumFolderTagDelete($input: AlbumFolderTagDeleteInput!) {
    albumFolderTagDelete(input: $input) {
      success
    }
  }
`;

export const albumAlbumFolderTagsCreate = gql`
  mutation albumAlbumFolderTagsCreate(
    $input: AlbumAlbumFolderTagsCreateInput!
  ) {
    albumAlbumFolderTagsCreate(input: $input) {
      album_album_folder_tags {
        id
        ...AlbumAlbumFolderTagDetails
      }
    }
  }
  ${AlbumAlbumFolderTagDetails}
`;

export const albumAlbumFolderTagsDelete = gql`
  mutation albumAlbumFolderTagsDelete(
    $input: AlbumAlbumFolderTagsDeleteInput!
  ) {
    albumAlbumFolderTagsDelete(input: $input) {
      success
    }
  }
`;

export const identityAlbumFolderTagsCreate = gql`
  mutation identityAlbumFolderTagsCreate(
    $input: IdentityAlbumFolderTagsCreateInput!
  ) {
    identityAlbumFolderTagsCreate(input: $input) {
      identity_album_folder_tags {
        ... on IRecord {
          id
        }
        ...IdentityAlbumFolderTagBaseDetails
        ...IdentityAlbumFolderUniformTagDetails
      }
    }
  }
  ${IdentityAlbumFolderTagBaseDetails}
  ${IdentityAlbumFolderUniformTagDetails}
`;

export const identityAlbumFolderTagUpdate = gql`
  mutation identityAlbumFolderTagUpdate(
    $input: IdentityAlbumFolderTagUpdateInput!
  ) {
    identityAlbumFolderTagUpdate(input: $input) {
      identity_album_folder_tag {
        ... on IRecord {
          id
        }
        ...IdentityAlbumFolderTagBaseDetails
        ...IdentityAlbumFolderUniformTagDetails
      }
    }
  }
  ${IdentityAlbumFolderTagBaseDetails}
  ${IdentityAlbumFolderUniformTagDetails}
`;

export const identityAlbumFolderTagsDelete = gql`
  mutation identityAlbumFolderTagsDelete(
    $input: IdentityAlbumFolderTagsDeleteInput!
  ) {
    identityAlbumFolderTagsDelete(input: $input) {
      success
    }
  }
`;

export const albumPhotosAlbumFolderTagsCreate = gql`
  mutation albumPhotosAlbumFolderTagsCreate(
    $input: AlbumPhotosAlbumFolderTagsCreateInput!
  ) {
    albumPhotosAlbumFolderTagsCreate(input: $input) {
      album_photo_album_folder_tags {
        ...AlbumPhotoAlbumFolderTagDetails
      }
    }
  }
  ${AlbumPhotoAlbumFolderTagDetails}
`;

export const albumPhotoAlbumFolderTagsDelete = gql`
  mutation albumPhotoAlbumFolderTagsDelete(
    $input: AlbumPhotoAlbumFolderTagsDeleteInput!
  ) {
    albumPhotoAlbumFolderTagsDelete(input: $input) {
      success
    }
  }
`;

export const albumFolderPhotoSearchCreate = gql`
  mutation albumFolderPhotoSearchCreate(
    $input: AlbumFolderPhotoSearchCreateInput!
  ) {
    albumFolderPhotoSearchCreate(input: $input) {
      album_folder_photo_search {
        ...AlbumFolderPhotoSearchDetails
      }
    }
  }
  ${AlbumFolderPhotoSearchDetails}
`;

export const albumFolderPhotoSearchUpdate = gql`
  mutation albumFolderPhotoSearchUpdate(
    $input: AlbumFolderPhotoSearchUpdateInput!
  ) {
    albumFolderPhotoSearchUpdate(input: $input) {
      album_folder_photo_search {
        ...AlbumFolderPhotoSearchDetails
      }
    }
  }
  ${AlbumFolderPhotoSearchDetails}
`;
export const albumFolderPhotoSearchDelete = gql`
  mutation albumFolderPhotoSearchDelete(
    $input: AlbumFolderPhotoSearchDeleteInput!
  ) {
    albumFolderPhotoSearchDelete(input: $input) {
      success
    }
  }
`;

export const albumPhotoSearchCreate = gql`
  mutation albumPhotoSearchCreate($input: AlbumPhotoSearchCreateInput!) {
    albumPhotoSearchCreate(input: $input) {
      album_photo_search {
        ...AlbumPhotoSearchDetails
      }
    }
  }
  ${AlbumPhotoSearchDetails}
`;

export const albumPhotoSearchUpdate = gql`
  mutation albumPhotoSearchUpdate($input: AlbumPhotoSearchUpdateInput!) {
    albumPhotoSearchUpdate(input: $input) {
      album_photo_search {
        ...AlbumPhotoSearchDetails
      }
    }
  }
  ${AlbumPhotoSearchDetails}
`;

export const albumPhotoSearchDelete = gql`
  mutation albumPhotoSearchDelete($input: AlbumPhotoSearchDeleteInput!) {
    albumPhotoSearchDelete(input: $input) {
      success
    }
  }
`;

export const uniformAlbumFolderTagLevelJerseysCreate = gql`
  mutation uniformAlbumFolderTagLevelJerseysCreate(
    $input: UniformAlbumFolderTagLevelJerseysCreateInput!
  ) {
    uniformAlbumFolderTagLevelJerseysCreate(input: $input) {
      uniform_album_folder_tag_level {
        id
        ...AlbumFolderTagLevelDetails
      }
    }
  }
  ${AlbumFolderTagLevelDetails}
`;

export const uniformAlbumFolderTagLevelJerseyUpdate = gql`
  mutation uniformAlbumFolderTagLevelJerseyUpdate(
    $input: UniformAlbumFolderTagLevelJerseyUpdateInput!
  ) {
    uniformAlbumFolderTagLevelJerseyUpdate(input: $input) {
      uniform_album_folder_tag_level_jersey {
        id
        name
        colors
        venue
      }
    }
  }
`;

export const uniformAlbumFolderTagLevelJerseyDelete = gql`
  mutation uniformAlbumFolderTagLevelJerseyDelete(
    $input: UniformAlbumFolderTagLevelJerseyDeleteInput!
  ) {
    uniformAlbumFolderTagLevelJerseyDelete(input: $input) {
      success
    }
  }
`;

export const uniformAlbumFolderTagLevelTeamsCreate = gql`
  mutation uniformAlbumFolderTagLevelTeamsCreate(
    $input: UniformAlbumFolderTagLevelTeamsCreateInput!
  ) {
    uniformAlbumFolderTagLevelTeamsCreate(input: $input) {
      uniform_album_folder_tag_level {
        id
        ...AlbumFolderTagLevelDetails
      }
    }
  }
  ${AlbumFolderTagLevelDetails}
`;

export const uniformAlbumFolderTagLevelTeamUpdate = gql`
  mutation uniformAlbumFolderTagLevelTeamUpdate(
    $input: UniformAlbumFolderTagLevelTeamUpdateInput!
  ) {
    uniformAlbumFolderTagLevelTeamUpdate(input: $input) {
      uniform_album_folder_tag_level_team {
        ...UniformAlbumFolderTagLevelTeam
      }
    }
  }
  ${UniformAlbumFolderTagLevelTeam}
`;

export const uniformAlbumFolderTagLevelTeamDelete = gql`
  mutation uniformAlbumFolderTagLevelTeamDelete(
    $input: UniformAlbumFolderTagLevelTeamDeleteInput!
  ) {
    uniformAlbumFolderTagLevelTeamDelete(input: $input) {
      success
    }
  }
`;
